var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mx-auto",attrs:{"height":"100","max-width":"200","outlined":""}}),_c('v-card',{staticClass:"mt-n12 mx-auto",attrs:{"elevation":"12","height":"200","max-width":"300"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }